module.exports = __webpack_public_path__ + "img/feat_private.11621e87.png";